<template>
    <div class="py-3">
        <v-row v-for="(parameterContext, idx) in parameterContexts" :key="idx" style="height: 80px;">
            <!-- <div style="float: left;"> -->
                <v-col cols="4" class="px-0" v-if="forSubProcess" style="padding-left: 12px !important;">
                    <!-- <md-select v-if="calleeDefinition" 
                            name="input" 
                            id="input" 
                            v-model="parameterContext.argument.text"
                    >
                        <md-option v-for="variable in calleeDefinition.processVariableDescriptors"
                                :key="variable.name"
                                :value="variable.name">
                        {{ variable.name }}
                        </md-option>
                    </md-select> -->
                    <v-select
                            v-if="calleeDefinition" 
                            v-model="parameterContext.argument.text"
                            :items="calleeDefinition.processVariableDescriptors"
                            item-text="name"
                            item-value="name"
                            label="피호출측 변수"
                    ></v-select>
                    <!-- <md-input 
                            v-else 
                            v-model="parameterContext.argument.text"
                            label="input" 
                            id="input"
                    ></md-input> -->
                    <v-text-field
                            v-else 
                            v-model="parameterContext.argument.text"
                            label="input" 
                            id="input"
                    ></v-text-field>
                </v-col>
                <v-col cols="2" v-else class="px-0" style="padding-left: 12px !important;">
                    <v-text-field 
                            name="input"
                            id="input"
                            :label="labelForArgument ? labelForArgument : '아규먼트'"
                            v-model="parameterContext.argument.text"
                    ></v-text-field>
                </v-col>
            <!-- </div> -->

            <!-- <div style="float: left;"> -->
                <v-col cols="2" v-if="parameterContext.transformerMapping" class="px-0">
                    <v-select
                            v-model="parameterContext.transformerMapping.transformer"
                            style="min-width: 20px;"
                            :items="transformerList"
                            label="변환"
                    ></v-select>
                    <!-- <md-select v-model="parameterContext.transformerMapping.transformer" style="min-width: 20px;">
                        <md-subheader>형태소 추출</md-subheader>
                        <md-option :value="{_type:'org.uengine.five.kernel.SemanticTransformer', entityType: 'SN'}">숫자 </md-option>
                        <md-option :value="{_type:'org.uengine.five.kernel.SemanticTransformer', entityType: 'NNP'}">이름 </md-option>
                        <md-option :value="{_type:'org.uengine.five.kernel.SemanticTransformer', entityType: 'NNG'}">직업 </md-option>
                    </md-select> -->
                </v-col>

                <v-col cols="2" class="px-0">
                    <v-select
                            v-model="parameterContext.direction"
                            style="min-width: 20px;" 
                            @change="directionChanged(parameterContext)"
                            :items="connectDirections"
                            label="연결방향"
                    >
                        <template v-slot:selection>
                            <v-icon>{{ iconForDirection(parameterContext.direction) }}</v-icon>
                            <!-- <v-icon>{{ iconForDirection(connectDirection) }}</v-icon> -->
                        </template>
                        <template v-slot:item="data">
                            <div v-if="data.item != 'OUT '">
                                <v-icon>{{iconForDirection(data.item)}}</v-icon>
                            </div>
                            <div v-else>
                                <v-icon>all_inclusive</v-icon><v-icon>{{iconForDirection(data.item)}}</v-icon>
                            </div>
                        </template>
                    </v-select>
                </v-col>
            <!-- </div> -->

            <v-col cols="4" class="px-0">
                <bpmn-variable-selector 
                        v-model="parameterContext.variable" 
                        :definition="definition"
                ></bpmn-variable-selector>
            </v-col>


            <!-- <md-layout style="width: 10%; float: left;">
                <md-checkbox v-model="parameterContext.split" v-if="forSubProcess">Split</md-checkbox>
                <md-checkbox v-model="parameterContext.multipleInput" v-if="multi">Multi</md-checkbox>
            </md-layout> -->

            <!-- <div style="width: 10%; float: left; margin-top: 20px; margin-left: 10px;"> -->
            <v-col cols="1" class="px-0" style="margin-top: 20px;">
                <v-icon @click.native="remove(parameterContext)"
                        color="primary"
                        style="cursor: pointer"
                >delete</v-icon>
            </v-col>
            <!-- </div> -->
        </v-row>

        <v-btn @click.native="add" color="primary">매핑 추가</v-btn>
    </div>
</template>

<script>

    export default {
        name: "bpmn-parameter-contexts",
        // computed: {
        //   calleeDefinition: function () {
      
        //     this.$root.codi('definition/' + this.calleeDefinitionId).get()
        //       .then(function (response) {
        //         me.calleeDefinition = response.data;
        //       })
      
        //     return {
      
        //       processVariableDescriptors: [
        //         {name: 'a'},
        //         {name: 'b'}
        //       ]
      
        //     }
        //   }
        // },
        props: {
            parameterContexts: Array,
            definition: Object,
            calleeDefinitionId: String,
            forSubProcess: Boolean,
            forCallActivity: Boolean,
            multi: Boolean,
            labelForArgument: String
        },
        data: function () {
            return {
                data: {
                  parameterContexts: this.parameterContexts,
                },
                calleeDefinition: null,
                // calleeDefinition: {
                //   processVariableDescriptors: [
                //     {name: '-- not loaded -- '},
                //   ]
                // }
                transformerList: [
                    { _type: null, entityType: null, text: '형태소 추출', disabled: true },
                    { _type: 'org.uengine.five.kernel.SemanticTransformer', entityType: 'SN', text: '숫자' },
                    { _type: 'org.uengine.five.kernel.SemanticTransformer', entityType: 'NNP', text: '이름' },
                    { _type: 'org.uengine.five.kernel.SemanticTransformer', entityType: 'NNG', text: '직업' },
                ],
                connectDirections: [ 'IN-OUT', 'IN', 'OUT', 'OUT ' ]
            };
        },
        watch: {
            data: {
                handler: function (after, before) {
                    // this.$emit('update:parameterContexts', after);
                },
                deep: true
            },
            calleeDefinitionId  : function(val){
                this.refreshCalleeDefinition();
            }
        },
        methods: {
            iconForDirection: function(direction){
                if(direction == "IN")
                    return "arrow_back";
                else if(direction == "OUT" || direction == "OUT ")
                    return "arrow_forward";
                else
                    return "settings_ethernet";
            },
            refreshCalleeDefinition: function(){
                if(!this.forSubProcess) return;

                if(this.forCallActivity){
                    var me = this;
                    this.$root.codi('definition/' + this.calleeDefinitionId + ".json").get()
                        .then(function (response) {
                            me.calleeDefinition = response.data.definition;
                    })
                } else {
                    me.calleeDefinition = this.definition;
                }
            },
            add: function () {
                this.parameterContexts.push({
                    direction: 'IN-OUT',
                    variable: {
                        name: 'name'
                    },
                    argument: {
                        text: 'arg'
                    }
                })
            },
            remove: function (parameterContext) {
                var index = this.parameterContexts.indexOf(parameterContext);
                //TODO: find and remove
                this.parameterContexts.splice(index,1)
            },
            directionChanged: function(parameterContext){
                if(parameterContext.direction == "OUT "){
                    parameterContext.direction = "OUT";
                    parameterContext.transformerMapping = {
                        _type: 'org.uengine.processdesigner.mapper.TransformerMapping',
                        transformer: {
                            _type: "org.uengine.five.kernel.SemanticTransformer",
                            entityType: "SSP"
                        }
                    }
                } else {
                    parameterContext.transformerMapping = null;
                }
            }
        }
    }

</script>


